import { render, staticRenderFns } from "./EditProductClass.vue?vue&type=template&id=12704e36&"
import script from "./EditProductClass.vue?vue&type=script&lang=js&"
export * from "./EditProductClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports